const SaveEvent = {}; 
export default SaveEvent;

SaveEvent.SAVE = "SaveEvent.SAVE";
SaveEvent.SAVED = "SaveEvent.SAVED";
SaveEvent.CLEAR = "SaveEvent.CLEAR";